import type {
  FindFlightOffersFlightSegmentV3,
  FindUserReservationsFlightReservationSegment,
  GetFlightAvailabilityTokenSegmentV2,
} from "@/types/codegen";

type Segment =
  | GetFlightAvailabilityTokenSegmentV2
  | FindUserReservationsFlightReservationSegment
  | FindFlightOffersFlightSegmentV3;

const isReservationSegment = (
  segment: Segment,
): segment is FindUserReservationsFlightReservationSegment => {
  return "origin" in segment && "destination" in segment;
};

export function extractAirlineCarriers<
  T extends
    | GetFlightAvailabilityTokenSegmentV2
    | FindUserReservationsFlightReservationSegment
    | FindFlightOffersFlightSegmentV3,
>(segments: T[]) {
  const carriers = segments?.map((segment) => {
    if (isReservationSegment(segment)) {
      if (!segment.marketingCarrier) {
        return null;
      }

      return {
        ...segment.marketingCarrier,
        flightNumber: segment.flightNumber,
        operatingCarrier: {
          ...segment.operatingCarrier,
          flightNumber: segment.flightNumber,
        },
      };
    }

    return {
      ...segment.marketingCarrier.airline,
      flightNumber: segment.marketingCarrier.flightNumber,
      operatingCarrier: {
        ...segment.operatingCarrier?.airline,
        flightNumber: segment.operatingCarrier?.flightNumber,
      },
    };
  });

  // Remove duplicates based on airline code and flight number
  const uniqueCarriers = carriers
    ?.filter((x): x is NonNullable<typeof x> => Boolean(x))
    .filter(
      (carrier, index, self) =>
        index === self.findIndex((t) => t.code === carrier.code),
    );

  return uniqueCarriers || null;
}
